<template>
    <div>
        <page-header :title="isEditing ? $t('pages.admin.faq.create_edit.title_edit') : $t('pages.admin.faq.create_edit.title')" icon-class="mdi mdi-frequently-asked-questions"/>
        <div class="row">
            <div class="col-12 grid-margin stretch-card">
                <div class="card shadow-sm">
                    <div class="card-body">
                        <language-switcher-nav :language.sync="selectedLanguage">
                            <div class="form-group">
                                <label :for="'title_' + selectedLanguage">{{ $t('pages.admin.faq.global.title') }}</label>
                                <input :id="'title_' + selectedLanguage" type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('titles.' + selectedLanguage)}" :placeholder="$t('pages.admin.faq.global.title')" v-model="titles[selectedLanguage]">
                                <error-no-form-field :input="'titles.' + selectedLanguage"/>
                            </div>

                            <div class="form-group">
                                <label :for="'text_' + selectedLanguage">{{ $t('pages.admin.faq.global.text') }}</label>
                                <VueTrix :id="'text_' + selectedLanguage" v-model="texts[selectedLanguage]" :placeholder="$t('pages.admin.faq.global.text')"></VueTrix>
                                <error-no-form-field :input="'texts.' + selectedLanguage"/>
                            </div>

                        </language-switcher-nav>


                        <div class="form-group">
                            <label>
                                <strong>
                                    {{ $t('pages.admin.faq.create_edit.image') }}
                                </strong>
                            </label>

                            <div class="mt-2 mb-2">
                                <img :src="current_image_url" :alt="titles.en" v-if="current_image_url !== null" class="img-fluid" style="max-height: 100px">
                            </div>

                            <input type="file" class="file-upload-default" id="file" :class="{'is-invalid': $errors.has('file')}" @change="fileSelected">
                            <div class="input-group cursor-pointer col-xs-12" @click="showSelectFileDialog">
                                <input type="text" class="form-control file-upload-info" disabled="" :placeholder="$t('pages.admin.faq.create_edit.image')">
                                <span class="input-group-append">
                                        <button class="file-upload-browse btn btn-gradient-primary" type="button">{{ $t('actions.select') }}</button>
                                    </span>
                                <error input="file"/>
                            </div>
                        </div>

                        <button class="btn btn-primary" @click="saveQuestion">
                            {{ isEditing ? $t('pages.admin.faq.create_edit.update') : $t('pages.admin.faq.create_edit.create') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "../../Includes/PageHeader";
import AdminFaqRepository from "../../../repositories/Admin/AdminFaqRepository";
import VueTrix from "vue-trix";
import LanguageSwitcherNav from "../../Includes/LanguageSwitcherNav";
export default {
name: "FaqCreateEdit",
    components: {LanguageSwitcherNav, PageHeader, VueTrix},
    data: () => ({
        questions: [],
        selectedLanguage: 'en',
        languages: ['en', 'de', 'lb'],

        file: null,

        titles: {
            en: '',
            de: '',
            lb: '',
        },

        texts: {
            en: '',
            de: '',
            lb: '',
        },

        current_image_url: null,
    }),
    computed: {
        selectedQuestion() {
            return this.$route.params.question !== undefined ? parseInt(this.$route.params.question) : null;
        },
        isEditing() {
            return this.selectedQuestion !== null;
        }
    },
    methods: {
        /* File Upload */
        fileSelected(e) {
            this.file = e.target.files[0];
            let fileUploadInfoInput = document.getElementsByClassName('file-upload-info')[0];
            fileUploadInfoInput.value = this.file.name;
            fileUploadInfoInput.value = fileUploadInfoInput.value.replace(/C:\\fakepath\\/i, '');
        },
        showSelectFileDialog() {
            let file = document.getElementsByClassName('file-upload-default')[0];
            file.click();
        },

        saveQuestion() {
            if(this.isEditing) {
                this.updateQuestion();
            } else {
                this.createQuestion();
            }
        },

        getFormData() {
            let formData = new FormData();

            if(this.file !== null)
                formData.append('file', this.file);

            formData.append('titles[en]', this.titles.en);
            formData.append('titles[de]', this.titles.de);
            formData.append('titles[lb]', this.titles.lb);

            formData.append('texts[en]', this.texts.en);
            formData.append('texts[de]', this.texts.de);
            formData.append('texts[lb]', this.texts.lb);

            return formData;
        },

        createQuestion() {
            AdminFaqRepository.createQuestion(this.getFormData()).then((res) => {
                this.$snotify.success(this.$t('pages.admin.faq.create_edit.created_successfully'));
                this.$router.push({name: 'admin.faq.index'});
            });
        },
        updateQuestion() {
            AdminFaqRepository.updateQuestion(this.selectedQuestion, this.getFormData()).then((res) => {
                this.$snotify.success(this.$t('pages.admin.faq.create_edit.updated_successfully'));
                this.$router.push({name: 'admin.faq.index'});
            });
        }
    },
    mounted() {
        // Hide Trix File Attachment Buttons
        let elements = document.querySelectorAll("[data-trix-button-group='file-tools']");
        elements.forEach(e => e.remove());

        if(this.isEditing) {
            AdminFaqRepository
                .getQuestion(this.selectedQuestion)
                .then((res) => {
                    this.titles = res.data.titles;

                    if(this.titles === null) {
                        this.texts = {en: '', de: '', lb: ''};
                    }

                    if(this.titles.de === "null")
                        this.titles.de = null;
                    if(this.titles.en === "null")
                        this.titles.en = null;
                    if(this.titles.lb === "null")
                        this.titles.lb = null;


                    this.texts = res.data.texts;

                    if(this.texts === null) {
                        this.texts = {en: '', de: '', lb: ''};
                    }

                    if(this.texts.de === "null")
                        this.texts.de = null;
                    if(this.texts.en === "null")
                        this.texts.en = null;
                    if(this.texts.lb === "null")
                        this.texts.lb = null;

                    this.current_image_url = res.data.image_url;
                });
        }
    }
}
</script>

<style scoped>

</style>
